import { render, staticRenderFns } from "./SubjectAddEdit.vue?vue&type=template&id=75c88e16"
import script from "./SubjectAddEdit.vue?vue&type=script&lang=js"
export * from "./SubjectAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports